import { User } from '@auth0/auth0-react';
import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import mixpanel from 'src/shared/lib/mixpanel';

const PLAYWRIGHT_USER_SUB = 'auth0|65f40e70642eb07dd2cf785f';

export function useRum(user: User | undefined) {
  useEffect(() => {
    if (user) {
      datadogRum.setUser({
        id: user.sub,
        name: user.nickname,
        email: user.email,
        verified: user.email_verified,
      });
      if (user.sub === PLAYWRIGHT_USER_SUB) {
        datadogRum.setUserProperty('playwright', true);
        mixpanel.register({ $ignore: true });
      }
      mixpanel.identify(user.sub);
    }
  }, [user]);
}
